import { CSSProperties } from 'react';
import { IconType } from '.';

interface AngleBracketProps extends IconType {
  style?: CSSProperties;
}

export default function AngleBracket({ className = 'icon', color = '#3E89F7', height = 6, style, width = 3 }: AngleBracketProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9.302" height="17.046" viewBox="0 0 9.302 17.046">
      <path
        id="angle-down-regular"
        d="M32.685,177.931l-7.361,6.93a1.047,1.047,0,0,1-.8.358,1.163,1.163,0,0,1-.8-.318l-7.361-6.971a1.163,1.163,0,1,1,1.6-1.69l6.562,6.214,6.562-6.218a1.161,1.161,0,0,1,1.644.045A1.174,1.174,0,0,1,32.685,177.931Z"
        transform="translate(185.22 -16.001) rotate(90)"
      />
    </svg>
  );
}
